import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

/**
 * Export only the label artwork to a PDF sized to the label dimensions (inches).
 * No workspace chrome, headers, or container mockup.
 */
export async function exportLabelToPdf(
  labelElement: HTMLElement,
  widthIn: number,
  heightIn: number,
  filename = 'product-label.pdf',
): Promise<void> {
  const clone = labelElement.cloneNode(true) as HTMLElement;
  const sandbox = document.createElement('div');
  sandbox.setAttribute('aria-hidden', 'true');
  sandbox.style.cssText =
    'position:fixed;left:-9999px;top:0;z-index:-1;background:#fff;overflow:hidden;';
  clone.style.margin = '0';
  clone.style.boxShadow = 'none';
  clone.id = 'label-pdf-export-clone';
  clone.querySelectorAll('[data-label-editor-chrome]').forEach((el) => el.remove());
  clone.querySelectorAll('.group').forEach((el) => {
    el.classList.remove('group', 'border-transparent', 'hover:border-sky-400/80');
    (el as HTMLElement).style.border = 'none';
  });
  sandbox.appendChild(clone);
  document.body.appendChild(sandbox);

  try {
    const canvas = await html2canvas(clone, {
      scale: Math.min(4, Math.max(2, 192 / Math.min(clone.offsetWidth, clone.offsetHeight))),
      backgroundColor: '#ffffff',
      logging: false,
      useCORS: true,
      allowTaint: true,
    });

    const orientation = widthIn >= heightIn ? 'landscape' : 'portrait';
    const pdf = new jsPDF({
      orientation,
      unit: 'in',
      format: [widthIn, heightIn],
      compress: true,
    });

    const imgData = canvas.toDataURL('image/png');
    pdf.addImage(imgData, 'PNG', 0, 0, widthIn, heightIn, undefined, 'FAST');
    pdf.save(filename);
  } finally {
    document.body.removeChild(sandbox);
  }
}
